import type * as Types from '../../../../../shared/generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CheckEmailExistQueryVariables = Types.Exact<{
  input: Types.CheckEmailExistInput;
}>;

export type CheckEmailExistQuery = {
  __typename?: 'Query';
  checkEmailExist: {
    __typename?: 'CheckEmailExistResponse';
    isExisted: boolean;
  };
};

export const CheckEmailExistDocument = gql`
  query CheckEmailExist($input: CheckEmailExistInput!) {
    checkEmailExist(input: $input) {
      isExisted
    }
  }
`;
export function useCheckEmailExistQuery(
  baseOptions: Apollo.QueryHookOptions<
    CheckEmailExistQuery,
    CheckEmailExistQueryVariables
  > &
    (
      | { variables: CheckEmailExistQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CheckEmailExistQuery, CheckEmailExistQueryVariables>(
    CheckEmailExistDocument,
    options,
  );
}
export function useCheckEmailExistLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CheckEmailExistQuery,
    CheckEmailExistQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CheckEmailExistQuery,
    CheckEmailExistQueryVariables
  >(CheckEmailExistDocument, options);
}
export function useCheckEmailExistSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CheckEmailExistQuery,
        CheckEmailExistQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CheckEmailExistQuery,
    CheckEmailExistQueryVariables
  >(CheckEmailExistDocument, options);
}
export type CheckEmailExistQueryHookResult = ReturnType<
  typeof useCheckEmailExistQuery
>;
export type CheckEmailExistLazyQueryHookResult = ReturnType<
  typeof useCheckEmailExistLazyQuery
>;
export type CheckEmailExistSuspenseQueryHookResult = ReturnType<
  typeof useCheckEmailExistSuspenseQuery
>;
export type CheckEmailExistQueryResult = Apollo.QueryResult<
  CheckEmailExistQuery,
  CheckEmailExistQueryVariables
>;
export function refetchCheckEmailExistQuery(
  variables: CheckEmailExistQueryVariables,
) {
  return { query: CheckEmailExistDocument, variables: variables };
}
